import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import RepairProcess from "./components/RepairProcess";
import WhyChooseUs from "./components/WhyChooseUs";
import ServicesAndPricing from "./components/ServicesAndPricing";
import RepairGallery from "./components/RepairGallery";
import B2BPartnership from "./components/B2BPartnership";
import Contact from "./components/Contact";
import CompanyInfo from "./components/CompanyInfo";
import Footer from "./components/Footer";

export default function Home() {
  useEffect(() => {
    const sections = document.querySelectorAll<HTMLElement>("section");
    sections.forEach((s) => s.classList.add("section-reveal"));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <RepairProcess />
      <WhyChooseUs />
      <ServicesAndPricing />
      <RepairGallery />
      <B2BPartnership />
      <Contact />
      <CompanyInfo />
      <Footer />
    </div>
  );
}
